/**
 * REWE Digital GmbH.
 * IT-Verticals
 *
 * zr-manufacturer component
 */

@use "../zr-theme/zr-variables.scss" as *;
@use "../zr-theme/functions/fonts.scss" as f;
@use "../zr-theme/fonts/open-sans.scss";

$component: 'zr-manufacturer';

.#{$component}__image {
    padding: 14px;

    img {
        max-width: 50%;
        height: auto;
        margin: 0 auto;
        display: block;
    }
}

.#{$component}__product-lines {
    text-align: center;
    padding: 14px;
}


.#{$component}__product-lines-headline {
    font-family: 'Open Sans', sans-serif;
    font-weight: 400;
    margin: 0;
    color: var(--ci-neutral700);
    line-height: 30px;
}

.#{$component}__product-lines-list {
    list-style: none;
    margin: 0;
    padding: 0;
}

.#{$component}__product-lines-link {
    font-family: 'Open Sans', sans-serif;
    font-weight: 600;
    transition: color .2s ease-out;
    color: var(--ci-neutral900);
    text-decoration: none;
    line-height: 30px;
    display: inline-block;

    &:hover {
        color: var(--ci-primary400);
        text-decoration: underline;
    }
}

.#{$component}__distributor {
    color: var(--ci-neutral900);
}

.#{$component}__distributor-text {
    span {
        display: block;
    }
}


// media query: mobile and above
@media only screen and (min-width: $tablet-screen) {
    .#{$component}__wrapper{
        display: flex;
    }

    .#{$component}__image {
        width: 50%;

        img {
            max-width: 100%;
        }
    }

    .#{$component}__product-lines {
        width: 50%;
    }
}
